export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_09.8fe9821c.png";